export enum ReportCustomFieldQualityControl {
  PASS = 'A96729A7-97E1-4758-8A84-071AE761A520',
  NO_PASS = '289D0707-DD42-46DF-8071-1C5720A339E0',
  PPP = '1348EC09-E05F-404B-8964-492ACA036172',
  PENDING = '66093220-A6D3-4F60-A94C-AD31CC2957A3',
  SAMPLE_PENDING = '4F23E963-14EE-4C46-9C69-AE2263A25EE2',
  LC_NO_PASS = '90CFF487-3B62-48F0-92CB-BAE708F4B824'
}
